import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { IMAGE_GALLERYDEC } from '../../../Constant';
import HeaderCard from '../../Common/HeaderCard';
import GalleryImageDesc from '../GalleryImageDesc';

const ListOfImageDesc = () => {
  return (
    <Col sm='12'>
      <Card>
        <HeaderCard title={IMAGE_GALLERYDEC} />
        <CardBody className='my-gallery row gallery-with-description'>
          <GalleryImageDesc />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ListOfImageDesc;
